// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0b89898f]:root {\n  --width: 100px;\n}\n.el-table th.text-column[data-v-0b89898f],\n.el-table td.text-column[data-v-0b89898f] {\n  width: var(--width);\n}", ""]);
// Exports
module.exports = exports;
